import { render, staticRenderFns } from "./ImpersonationButton.vue?vue&type=template&id=42afa654&scoped=true&"
import script from "./ImpersonationButton.vue?vue&type=script&lang=ts&"
export * from "./ImpersonationButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afa654",
  null
  
)

export default component.exports